
import { useContext } from "react";
import { billingContext } from "@/contexts/billing";

export function useBilling() {
  return useContext(billingContext);
}
